import type { ServiceGetByIdResponse } from '@/types/service'

import type {
  RecapClassPoktan,
  RecapClassPoktanDetail,
  RecapClassPoktanMeta,
  RecapClassPoktanSummary
} from './types'

type RecordType = 'detail' | 'summary'

export type RecapClassPoktanRecord<TType extends RecordType> =
  TType extends 'detail'
    ? RecapClassPoktanDetail & { recordType: 'detail' }
    : RecapClassPoktanSummary & { recordType: 'summary' }

export type RecapClassPoktanData = Array<
  RecapClassPoktanRecord<'detail'> | RecapClassPoktanRecord<'summary'>
>

export interface RecapClassPoktanQueryResult {
  data: RecapClassPoktanData
  meta?: RecapClassPoktanMeta | null
}

type RecapClassPoktanApiResponse = ServiceGetByIdResponse<RecapClassPoktan> & {
  meta?: RecapClassPoktanMeta
}

export function toRecords(
  json: RecapClassPoktanApiResponse
): RecapClassPoktanQueryResult {
  const data = json.data

  if (!data) {
    return {
      data: [],
      meta: json.meta ?? null
    }
  }

  const summary = [
    {
      ...data.summary,
      recordType: 'summary'
    } satisfies RecapClassPoktanRecord<'summary'>
  ]

  const details = data.detail.map(
    item =>
      ({
        ...item,
        recordType: 'detail'
      }) satisfies RecapClassPoktanRecord<'detail'>
  )

  return {
    data: [...details, ...summary],
    meta: json.meta ?? null
  }
}
